
export default {
  name: 'EmptyState',
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconUrl() {
      return require(`@/assets/img/${this.type}.svg`);
    },
    title() {
      switch (this.type) {
        case 'purchases':
          return `${this.$t('shop.prevPurchasesEmptyTitle')}`;
        case 'favorites':
          return `${this.$t('shop.favoritesEmptyTitle')}`;
        case 'watchlist':
          return `${this.$t('shop.watchlistEmptyTitle')}`;
        default:
          return null;
      }
    },
    message() {
      switch (this.type) {
        case 'purchases':
          return `${this.$t('shop.prevPurchasesEmptyText')}`;
        case 'favorites':
          return `${this.$t('shop.favoritesEmptyText')}`;
        case 'watchlist':
          return `${this.$t('shop.watchlistEmptyText')}`;
        default:
          return null;
      }
    },
  },
};
